import { useConfigStore } from '../stores/config'

declare global {
	interface Window {
		dataLayer: ((string | Date)[] | { event: string })[]
		gtag: (...args: (string | Date)[] | { event: string }[]) => void
	}
}

export const init = () => {
	const config = useConfigStore()
	const gtmToken = config.config.gtm_token

	if (!gtmToken) return

	const pushConfig = () => {
		window.dataLayer = window.dataLayer || []
		window.gtag =
			window.gtag ||
			function gtag() {
				// eslint-disable-next-line prefer-rest-params
				window.dataLayer.push(arguments as unknown as (string | Date)[] | { event: string })
			}
		window.gtag('js', new Date())
		window.gtag('config', gtmToken)
	}

	if (!window.gtag) {
		const scriptEl = document.createElement('script')
		scriptEl.async = true
		scriptEl.onload = pushConfig
		scriptEl.src = `https://www.googletagmanager.com/gtag/js?id=${gtmToken}`
		document.body.appendChild(scriptEl)
	} else {
		pushConfig()
	}
}

export const gtagCall = (...args: unknown[]) => {
	if (!window.gtag) return

	const config = useConfigStore()
	const gtmToken = config.config.gtm_token
	if (gtmToken) {
		args = [...args, { send_to: gtmToken }]
	}

	window.gtag(...(args as (string | Date)[] | { event: string }[]))
}
